import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const createPaymentCheckout = async (paymentData) => {
  try {
    const origin_url = window.location.origin;
    
    const response = await axios.post(
      `${API}/payments/create-checkout?origin_url=${encodeURIComponent(origin_url)}`,
      paymentData
    );
    
    if (response.data.checkout_url) {
      // Redirect to Stripe Checkout
      window.location.href = response.data.checkout_url;
      return response.data;
    } else {
      throw new Error('No checkout URL received');
    }
  } catch (error) {
    console.error('Payment error:', error);
    throw error;
  }
};

export const getPaymentStatus = async (sessionId) => {
  try {
    const response = await axios.get(`${API}/payments/status/${sessionId}`);
    return response.data;
  } catch (error) {
    console.error('Error checking payment status:', error);
    throw error;
  }
};
